// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('tasks.assigned', {
    url: '/assigned',
    templateUrl: 'main/tasks/assigned/assigned.tpl.html',
    controller: 'AssignedTasksController as vm',
    data: { pageTitle: 'Tasks' },
  });
};

class AssignedTasksController {
  constructor(
    $scope,
    $filter,
    DS,
    toasterService,
    loadSpinnerService,
    TasksApiService,
    HelperService,
    currentUser,
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$filter = $filter;
    this.DS = DS;
    this.toasterService = toasterService;
    this.loadSpinnerService = loadSpinnerService;
    this.TasksApiService = TasksApiService;
    this.HelperService = HelperService;
    this.currentUser = currentUser;

    this.selectedTask = {};
    this.tasks = [];
    this.articles = [];
    this.selectedArticle = null;
    this.completed = false;
    this.tasksCount = 0;
    this.page = 1;
    this.pageSizes = [10, 15, 50, 100];
    this.pageSize = 50;
    this.onPaginate = (page, pageSize) => {
      this.page = page;
      this.pageSize = pageSize;
      this.selectTask(null);
      this.loadTasks();
    };
    this.loadTasks();
  }

  loadTasks() {
    this.loadSpinnerService.start('mainSpinner');
    return this.TasksApiService.getAllByUserId(this.currentUser.id, {
      page: this.page,
      limit: this.pageSize,
      articleId: this.selectedArticle ? this.selectedArticle.id : 0,
      completed: this.completed,
    })
      .then(({ items, totalItems, filters: { articles } }) => {
        this.tasks = items;
        this.tasksCount = totalItems;
        this.articles = articles;
      })
      .finally(() => {
        this.loadSpinnerService.stop('mainSpinner');
      });
  }

  selectTask(task) {
    if (!task) {
      this.selectedTask = {};
      return;
    }
    if (task.id === this.selectedTask.id) {
      return;
    }

    this.loadSpinnerService.start('mainSpinner');
    this.TasksApiService.getById(task.id, {
      includeRelations: ['creator', '_taskUsers.user'],
    })
      .then((task) => {
        this.selectedTask = task;
      })
      .finally(() => {
        this.loadSpinnerService.stop('mainSpinner');
      });
  }

  deleteTask() {
    this.articles = [];
    this.selectTask(null);
  }

  toggleDoneStatus(task) {
    this.loadSpinnerService.start('mainSpinner');
    this.TasksApiService.updateTask(task.id, { isDone: task.isDone })
      .then(() => {
        this.toasterService.success();
        return this.loadTasks();
      })
      .finally(() => {
        this.loadSpinnerService.stop('mainSpinner');
      });
  }

  setCompleted(completed) {
    this.completed = completed;
    this.loadTasks();
  }

  filterArticles(query) {
    return _.orderBy(
      _.filter(this.articles, (a) =>
        this.HelperService.containsText(a, { name: query, itemCode: query }),
      ),
      'itemCode',
    );
  }

  selectedArticleChanged() {
    this.selectTask(null);
    this.loadTasks();
  }
}

angular
  .module('main.tasks.assigned', [])
  .config(config)
  .controller('AssignedTasksController', AssignedTasksController);
